<template>
    <div v-if="internalActive" class="progress-bar-overlay">
        <progress id="progress-bar" :value="actual" max="100" class="custom-progress">
            {{ actual }}%
        </progress>
        <label for="progress-bar" class="progress-label">{{ actual }}%</label>
    </div>
</template>

<script>

import { loadingState } from "../../services/LoadingState";
export default {
    name: 'ProgressBarContador',
    props: {
        active: {
            type: Boolean,
            required: false,//false
        }
    },
    data() {
        return {
            actual: 0,
            internalActive: false,//false
            interval: null
        };
    },
    computed: {
        progress() {
            return Math.min(this.actual, 100);
        }
    },
    watch: {
        async active(newVal) {
            if (newVal) {
                loadingState.isLoading = true;
                this.startProgress();
            } else {
                await this.stopProgress();
            }
        },
    },

    methods: {
        async startProgress() {
            this.internalActive = true;
            this.actual = 0;

            const maxVisualProgress = 80;
            const duration = 20000; // cuánto tiempo tarda en llegar al 80%
            const steps = maxVisualProgress;
            const intervalTime = duration / steps;

            this.interval = setInterval(() => {
                if (this.actual < maxVisualProgress) {
                    this.actual += 1;
                }
            }, intervalTime);
        },

        async stopProgress() {
            // Detener progreso automático
            clearInterval(this.interval);
            this.interval = null;

            // Completar hasta 100 de forma suave
            const finishInterval = setInterval(() => {
                if (this.actual < 100) {
                    this.actual += 1;
                } else {
                    clearInterval(finishInterval);
                    setTimeout(() => {
                        this.internalActive = false;
                        this.actual = 0;
                        loadingState.isLoading = false;
                    }, 500);
                }
            }, 20); // velocidad de finalización
        }


    },//Fin Methods
    beforeDestroy() {
        clearInterval(this.interval);
    }

};
</script>

<style scoped>
.progress-bar-overlay {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    z-index: 9999;
    padding: 20px;
    /* Un poco más de aire */
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Estilos para la etiqueta nativa */
.custom-progress {
    width: 100%;
    height: 25px;
    appearance: none;
    /* Quitar estilos default */
    border: none;
}

/* Fondo de la barra (Chrome, Safari, Edge) */
.custom-progress::-webkit-progress-bar {
    background-color: #e9ecef;
    border-radius: 5px;
}

/* Parte que se llena (Chrome, Safari, Edge) */
.custom-progress::-webkit-progress-value {
    background-color: #036194;
    border-radius: 5px;
    transition: width 0.3s ease;
    /* Movimiento suave */
}

/* Estilo para el porcentaje */
.progress-label {
    margin-top: 10px;
    font-weight: bold;
    color: #036194;
    font-family: sans-serif;
}

.progress {
    height: 20px;
    background-color: #e9ecef;
    border-radius: 5px;
    overflow: hidden;
}

.progress-bar {
    background-color: #036194;
    transition: width 0.3s;
    text-align: center;
    color: white;
    font-weight: bold;
}

.progress-barDefault {
    padding-top: 9px;
    background-color: #b5babd;
    text-align: center;
    color: #000;
    font-weight: bold;
}
</style>